export default () => ({
  dialogContent: {
    padding: '24px',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  section: {
    marginBottom: '24px',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '12px',
    color: '#333',
  },
  field: {
    marginBottom: '12px',
  },
  fieldLabel: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#666',
    marginBottom: '4px',
  },
  fieldValue: {
    fontSize: '14px',
    color: '#333',
    wordBreak: 'break-word',
  },
  messageText: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    fontSize: '14px',
    lineHeight: '1.6',
    color: '#333',
    padding: '12px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
  },
  invoiceItem: {
    padding: '12px',
    backgroundColor: '#f9f9f9',
    borderRadius: '4px',
    marginBottom: '8px',
  },
  invoiceItemAccordion: {
    marginBottom: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    '&:before': {
      display: 'none',
    },
  },
  statusChip: {
    fontSize: '11px',
    height: '24px',
  },
});
